import { useEffect, useState } from "react";
import pageSettled from "./pageSettled";

// Whether what `ref` holds, further down the page, may load: once the page
// has settled (pageSettled.js), or as soon as the visitor comes within a
// screen of it, whichever is first. False as the page is built and while
// React attaches to it, so both have the same markup.
export default function useDeferredLoad(ref) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (ready) return undefined;
    let live = true;
    const load = () => live && setReady(true);
    pageSettled().then(load);
    const near = new IntersectionObserver((entries) => entries.some((entry) => entry.isIntersecting) && load(), { rootMargin: "100% 0px" });
    near.observe(ref.current);
    return () => {
      live = false;
      near.disconnect();
    };
  }, [ready, ref]);
  return ready;
}
